.vx-checkbox {
  display: flex;
  gap: 16px;
  margin-bottom: 0;
  cursor: pointer;
  isolation: isolate;
  border-radius: 8px;
  padding: 8px 0 8px 10px;
  color: var(--vx-checkbox--label-color, #3C3C3C);
}
.vx-checkbox:focus-within, .vx-checkbox:hover {
  outline: none;
  background: var(--ci-primary400);
  color: #fff;
  transition-property: color, background-color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.vx-checkbox__input {
  display: block;
  position: relative;
  accent-color: var(--vx-input-accent-color);
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
  pointer-events: none;
  flex-shrink: 0;
}

.vx-checkbox__input:disabled {
  background-color: #fff;
}

.vx-checkbox__label {
  display: block;
  padding-left: 33px;
  transform: translateX(-33px);
  font-size: 16px;
  color: inherit;
  line-height: 1;
  z-index: 5;
}